module.exports = __webpack_public_path__ + "fonts/Inter-500-cyrillic-ext50.df55b7e.woff2";